import React from "react";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import searcher from "../../../assets/icons/searchInput.svg";
import CreateBtn from "../../../components/buttons/createBtn";
import TrainingQaListTable from "./training-qa-list-table";
import { useLocation, useNavigate } from "react-router-dom";

const TrainingQaList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  return (
    <MainLayout breadCrumb="ADMIN / FIELD FORCE TRAINING / Q/A">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} color={""} />
            <input
              value={search}
              className="search-input fs_14 text-dark fw_400 px-2"
              type="text"
              placeholder="Search here..."
              onChange={(e) =>
                navigate(
                  `/ff-training/qa?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                )
              }
            />
          </div>

          <div className=" d-flex justify-content-between m-1 mb-2">
            <CreateBtn link="/ff-training/qa/create" />
          </div>
        </div>
        <TrainingQaListTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default TrainingQaList;
